import { render } from "./Rtpi.vue?vue&type=template&id=2ab5c372&scoped=true&lang=pug"
import script from "./Rtpi.vue?vue&type=script&lang=ts"
export * from "./Rtpi.vue?vue&type=script&lang=ts"

import "./Rtpi.vue?vue&type=style&index=0&id=2ab5c372&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ab5c372"

export default script